import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkyMediaQueryModule } from '../media-queries';

import { SkyActionButtonComponent } from './action-button.component';
import { SkyActionButtonIconComponent } from './action-button-icon.component';
import { SkyActionButtonHeaderComponent } from './action-button-header.component';
import { SkyActionButtonDetailsComponent } from './action-button-details.component';
import { SkyActionButtonContainerComponent } from './action-button-container.component';


export class SkyActionButtonModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyActionButtonComponent,
    SkyActionButtonIconComponent,
    SkyActionButtonHeaderComponent,
    SkyActionButtonDetailsComponent,
    SkyActionButtonContainerComponent
  ],
  imports: [
    CommonModule,
    SkyMediaQueryModule
  ],
  exports: [
    SkyActionButtonComponent,
    SkyActionButtonIconComponent,
    SkyActionButtonHeaderComponent,
    SkyActionButtonDetailsComponent,
    SkyActionButtonContainerComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
